import React from 'react';

const VARIANTS = {
  mutedFallback: 'badge badge--muted',
  present: 'badge badge--success',
  late: 'badge badge--warning',
  absent: 'badge badge--danger',
  remote: 'badge badge--info',
  leave: 'badge badge--muted',
  cat_general: 'badge badge--muted',
  cat_rrhh: 'badge badge--info',
  cat_compliance: 'badge badge--warning',
  cat_leadership: 'badge badge--info',
  cat_technical: 'badge badge--muted',
  cat_wellness: 'badge badge--success',
  cat_benefits: 'badge badge--success',
  cat_urgent: 'badge badge--danger',
  aud_all: 'badge badge--muted',
  aud_managers: 'badge badge--info',
  aud_employees: 'badge badge--info',
  active: 'badge badge--success',
  onboarding: 'badge badge--info',
  inactive: 'badge badge--muted',
  offboarding: 'badge badge--warning',
  pending: 'badge badge--warning',
  approved: 'badge badge--success',
  rejected: 'badge badge--danger',
  cancelled: 'badge badge--muted',
  draft: 'badge badge--muted',
  submitted: 'badge badge--info',
  manager_approved: 'badge badge--info',
  finance_approved: 'badge badge--success',
  paid: 'badge badge--success',
  not_synced: 'badge badge--muted',
  pending_sync: 'badge badge--warning',
  synced: 'badge badge--success',
  error: 'badge badge--danger',
  product_active: 'badge badge--product-active',
  product_prepared: 'badge badge--product-prepared',
  hr_pending: 'badge badge--hr-pending',
  hr_uploaded: 'badge badge--hr-uploaded',
  hr_approved: 'badge badge--hr-approved',
  hr_rejected: 'badge badge--hr-rejected',
  hr_expired: 'badge badge--hr-expired',
  lifecycle_pending: 'badge badge--lifecycle-pending',
  lifecycle_in_progress: 'badge badge--lifecycle-in-progress',
  lifecycle_blocked: 'badge badge--lifecycle-blocked',
  lifecycle_completed: 'badge badge--lifecycle-completed',
};

export function Badge({ children, variant }) {
  const cls = VARIANTS[variant] || VARIANTS.mutedFallback;
  return <span className={cls}>{children}</span>;
}
